// Generated by ts-to-zod
import { z } from 'zod';
import { queueSchema } from '../models/queue.schema';

export const queuePatchPayloadSchema = queueSchema.partial();
